import React, { useState, useEffect } from 'react';
import { array, object } from 'prop-types';

import { get, isEmpty } from 'lodash';

import queryString from 'query-string';

import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import { useFormik } from 'formik';
import * as Yup from 'yup';

import Checkbox from '@material-ui/core/Checkbox';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import MenuItem from '@material-ui/core/MenuItem';
import Paper from '@material-ui/core/Paper';
import Select from '@material-ui/core/Select';
import TextField from '@material-ui/core/TextField';

import PlacesAutocomplete, { geocodeByAddress, getLatLng } from 'react-places-autocomplete';

import Button from '@material-ui/core/Button';
import GoogleLogo from '../../../components/GoogleLogo';
import BobConfirmButton from './../../../components/BobConfirmButton';
import BobLoadingMask from '../../../components/BobLoadingMask';

import * as ArchitectActions from '../../../actions/architectActions';
import * as ApplicationMessageActions from '../../../actions/applicationMessageActions';
import * as ContactActions from '../../../actions/contactActions';
import * as DashboardActions from '../../../actions/dashboardActions';
import * as UiActions from '../../../actions/uiActions';

import classes from '../CreateEntityModal.module.css';
import TimeZoneAutoSelect from '../../../components/TimeZoneAutoSelect';
import { squareAreaUOMTypes } from '../../../data/areaTypes';

const ValidationSchema = Yup.object().shape({
    clientId: Yup.string()
        .max(45)
        .required(),
    name: Yup.string()
        .max(45)
        .required(),
    buildingType: Yup.string()
        .required(),
    squareFootage: Yup.number()
        .required(),
    fuelTypes:         Yup.array(),
    salesContact:      Yup.string(),
    facilitiesContact: Yup.string(),
    energyContact:     Yup.string(),
    energySite:        Yup.string(),
    timeZone:          Yup.string().required(),
    squareAreaUOM:     Yup.string(),
    addressSearch:     Yup.string()
        .required()
});

const CreateSiteModal = ({
    bobLoading,
    contacts,
    companyApplications,
    isLoading,
    errors,
    selectedNode,
    clearContacts,
    clearErrors,
    toggleLoading,
    buildingTypes,
    clientNodes,
    energyIntegrations,
    fuelTypes,
    fetchContacts,
    fetchEnergyPrintIntegrations,
    fetchSiteContacts,
    fetchSiteListAfterCreate,
    fetchSites,
    fetchSiteData,
    history,
    isEdit,
    navClients,
    onClose,
    site,
    siteContacts,
    targetNavClient,
    targetNavCompany,
    activeNavClient,
    updateEnergyPrintIntegration,
    ...props
}) => {
    const [address, setAddress] = useState({});
    const [address1, setAddress1] = useState('');
    const [city, setCity] = useState('');
    const [state, setState] = useState('');
    const [zip, setZip] = useState('');
    const [integrationId, setIntegrationId] = useState('');
    const [initialValues, setInitialValues] = useState({
        clientId:          !isEdit ? activeNavClient && activeNavClient.id ? activeNavClient.id : '' : site && site.clientId ? site.clientId : '',
        name:              '',
        buildingType:      '',
        squareFootage:     '',
        fuelTypes:         [],
        salesContact:      '',
        facilitiesContact: '',
        energyContact:     '',
        timeZone:          '',
        energySite:        '',
        squareAreaUOM:     'SquareFootage',
        addressSearch:     ''
    });

    useEffect(() => {
        if (site && site.siteId) {

            //Use site contacts endpoint
            fetchSiteContacts(site.clientId, site.siteId);
            //fetchContacts(site.clientId);

            fetchSiteData(site.siteId).then(siteData => {
                let siteDataObj = {
                    clientId:          get(site, 'clientId', ''),
                    name:              get(siteData, 'name', ''),
                    buildingType:      get(siteData, 'buildingType.id', ''),
                    squareFootage:     get(siteData, 'squareFootage', ''),
                    squareAreaUOM:     get(siteData, 'squareAreaUOM', ''),
                    fuelTypes:         [],
                    salesContact:      get(siteData, 'salesContact.id', ''),
                    facilitiesContact: get(siteData, 'facilitiesContact.id', ''),
                    energyContact:     get(siteData, 'energyContact.id', ''),
                    energySite:        '',
                    addressSearch:     '',
                    timeZone:          get(siteData, 'timeZone', '')
                };

                const selectedEnergySite = energyIntegrations.find(integration => integration.siteId === site.siteId);
                if (selectedEnergySite) {
                    siteDataObj.energySite = selectedEnergySite.integrationId;
                    setIntegrationId(selectedEnergySite.integrationId);
                }

                if (siteData.fuelTypes) {
                    // eslint-disable-next-line array-callback-return
                    siteData.fuelTypes.map(item => {
                        siteDataObj.fuelTypes.push(item.name);
                    });
                }

                setInitialValues(siteDataObj);

                // update address fields
                if (siteData.address) {
                    handleGeocodeAddress(siteData.address.formattedAddress);
                }
            });
        }
    }, [site]);

    useEffect(() => {
        return () => {
            setIntegrationId('');
        };
    }, []);

    const formik = useFormik({
        initialValues:      initialValues,
        validationSchema:   ValidationSchema,
        enableReinitialize: true,
        onSubmit:           async (values, { setSubmitting }) => {
            const {
                createArchitectSite,
                updateSite
            } = props;

            let siteId;
            let isUpdated;

            let fuelTypeIds = fuelTypes.filter(f => formik.values.fuelTypes.includes(f.name)).map(type => type.id);

            const timeZone = values.timeZone.name ? values.timeZone.name : values.timeZone;
            const body = {
                name:           values.name,
                buildingTypeId: values.buildingType,
                squareFootage:  values.squareFootage,
                squareAreaUOM:  values.squareAreaUOM,
                fuelTypes:      fuelTypeIds,
                timeZone:       timeZone,
                address
            };

            //if (!isEmpty(values.facilitiesContact)) body.facilitiesContactId = values.facilitiesContact;
            //if (!isEmpty(values.salesContact)) body.salesContactId = values.salesContact;
            //if (!isEmpty(values.energyContact)) body.energyContactId = values.energyContact;

            clearErrors();
            setSubmitting(true);

            const companyInfo = {
                companyId: targetNavCompany.id
            };

            try {
                if (!isLoading) {
                    toggleLoading(true);
                    // site is already exist so call update method.
                    if (isEdit) {
                        isUpdated = await updateSite(site.siteId, body);
                        body.id = site.siteId;
                        //Check if we need to update the EP link or remove the EP link
                        if (integrationId) {
                            if (values.energySite && (integrationId !== values.energySite)) {
                                await updateEnergyPrintIntegration(companyInfo.companyId, site.siteId, values.energySite);
                                await fetchEnergyPrintIntegrations(companyInfo.companyId);
                            }
                            if (!values.energySite) {
                                await updateEnergyPrintIntegration(companyInfo.companyId, null, integrationId);
                                await fetchEnergyPrintIntegrations(companyInfo.companyId);
                            }
                        } else {
                            if (values.energySite) {
                                await updateEnergyPrintIntegration(companyInfo.companyId, site.siteId, values.energySite);
                                await fetchEnergyPrintIntegrations(companyInfo.companyId);
                            }
                        }
                    } else {
                        if (selectedNode.type === 'campus') {
                            const campusId = selectedNode.id;
                            siteId = await createArchitectSite(values.clientId, companyInfo, body, campusId);
                        } else {
                            siteId = await createArchitectSite(values.clientId, companyInfo, body);
                        }
                        if (values.energySite) {
                            await updateEnergyPrintIntegration(companyInfo.companyId, siteId, values.energySite);
                            await fetchEnergyPrintIntegrations(companyInfo.companyId);
                        }
                    }

                }

                // On Create
                if (!isEmpty(siteId)) {
                    let path = '/v2/dashboard/site';

                    const queryValues = queryString.parse(history.location.search);
                    queryValues.client = values.clientId;
                    queryValues.site = siteId;
                    queryValues.parentId = 'c0c505f5-c7fc-4317-8cb6-f6e631142a77';
                    queryValues.childId = 'bb5be75b-d466-48d5-99da-79cd66504f20';

                    // Find client to populate out selected nav client
                    const client = navClients.find(client => client.id === values.clientId);
                    body.clientId = values.clientId;
                    body.clientName = client.name;
                    fetchSiteListAfterCreate(body, 'create');
                    body.id = siteId;

                    //Update Url to move to the created entity overview page
                    const queryValuesString = queryString.stringify(queryValues);
                    history.push(`${path}?${queryValuesString}`);
                }

                if (isUpdated) {
                    handleClose(body, 'update');
                }
                else {
                    toggleLoading(false);
                    setSubmitting(false);
                }
            } catch (error) {
                setSubmitting(false);
            }
        }
    });

    const handleGeocodeAddress = async address => {
        try {
            const results = await geocodeByAddress(address);
            const latLng = await getLatLng(results[0]);

            const streetNumber = results[0].address_components.find(result => {
                return result.types.includes('street_number');
            });

            const route = results[0].address_components.find(result => {
                return result.types.includes('route');
            });

            const city = results[0].address_components.find(result => {
                return result.types.includes('locality');
            });

            const subLocality = results[0].address_components.find(result => {
                return result.types.includes('sublocality');
            });

            const administrativeAreaLevel2 = results[0].address_components.find(result => {
                return result.types.includes('administrative_area_level_2');
            });

            const administrativeAreaLevel3 = results[0].address_components.find(result => {
                return result.types.includes('administrative_area_level_3');
            });

            const state = results[0].address_components.find(result => {
                return result.types.includes('administrative_area_level_1');
            });

            const zip = results[0].address_components.find(result => {
                return result.types.includes('postal_code');
            });

            const country = results[0].address_components.find(result => {
                return result.types.includes('country');
            });

            const address1Check = streetNumber ? `${streetNumber.long_name} ${route.long_name}` : route.long_name;
            const cityCheck = city ? city.long_name : administrativeAreaLevel3 ? administrativeAreaLevel3.long_name  : subLocality ? subLocality.long_name : '';

            formik.setFieldValue('addressSearch', results[0].formatted_address);

            setAddress1(address1Check);
            setCity(cityCheck);
            setState(state.short_name);
            setZip(zip.long_name);

            setAddress({
                latitude:                 get(latLng, 'lat', ''),
                longitude:                get(latLng, 'lng', ''),
                administrativeAreaLevel1: get(state, 'short_name', ''),
                administrativeAreaLevel2: get(administrativeAreaLevel2, 'long_name', ''),
                country:                  get(country, 'short_name', ''),
                locality:                 cityCheck,
                postalCode:               get(zip, 'long_name', ''),
                route:                    get(route, 'long_name', ''),
                streetNumber:             streetNumber ? streetNumber.long_name : '',
                formattedAddress:         get(results[0], 'formatted_address', '')
            });
        } catch (error) {
            // eslint-disable-next-line no-console
            console.warn('Error: ', error);
        }
    };

    const handleClose = (body, type) => {
        //Get client id to refetch nav sites
        if (!body.clientId) {
            const client = navClients.find(client => client.id === site.clientId);
            body.clientId = site.clientId;
            body.clientName = client.name;
        } else {
            const client = navClients.find(client => client.id === body.clientId);
            body.clientId = site.clientId;
            body.clientName = client.name;
        }

        toggleLoading(false);
        clearErrors();
        clearContacts();
        fetchSiteListAfterCreate(body, type);
        onClose();
    };

    const handleCancel = () => {
        clearContacts();
        onClose();
    };

    return (
        <React.Fragment>
            <div className={classes.inputs}>
                <FormControl className={classes.inputWrapperHalf}>
                    <InputLabel
                        htmlFor="clientId"
                        classes={{
                            error:   classes.error,
                            focused: classes.labelFocused,
                            root:    classes.label
                        }}
                        error={Boolean(formik.errors.clientId) && Boolean(formik.touched.clientId)}
                    >
                        Select Client<span className={classes.required}> *</span>
                    </InputLabel>
                    <Select
                        value={formik.values.clientId}
                        onChange={ e => {
                            fetchContacts(e.target.value);
                            formik.handleChange(e);
                        }}
                        className={classes.select}
                        disabled={isEdit}
                        inputProps={{
                            name:   'clientId',
                            id:     'clientId',
                            onBlur: formik.handleBlur
                        }}
                        error={Boolean(formik.errors.clientId) && Boolean(formik.touched.clientId)}
                    >
                        {
                            navClients.map(type =>
                                <MenuItem
                                    key={type.id}
                                    value={type.id}
                                >
                                    {type.name}
                                </MenuItem>
                            )
                        }
                    </Select>
                    {formik.touched.clientId &&
                        formik.errors.clientId && <FormHelperText className={classes.error}>{formik.errors.clientId}</FormHelperText>}
                </FormControl>
            </div>
            <div className={classes.formColumn}>
                <div className={classes.inputColumn}>
                    <div className={classes.inputs}>
                        <FormControl className={classes.inputWrapper}>
                            <TextField
                                id="name"
                                name="name"
                                type="text"
                                value={formik.values.name}
                                label={<span>Site Name<span className={classes.required}> *</span></span>}
                                onChange={formik.handleChange}
                                InputLabelProps={{
                                    classes: {
                                        error:   classes.error,
                                        focused: classes.labelFocused,
                                        root:    classes.label
                                    }
                                }}
                                InputProps={{
                                    onBlur:  formik.handleBlur,
                                    classes: {
                                        error:     classes.cssErrorUnderline,
                                        underline: classes.cssUnderline,
                                        root:      classes.input
                                    }
                                }}
                                FormHelperTextProps={{
                                    classes: {
                                        error: classes.error
                                    }
                                }}
                                error={Boolean(formik.errors.name) && Boolean(formik.touched.name)}
                                helperText={Boolean(formik.touched.name) && formik.errors.name}
                            />
                        </FormControl>
                        <FormControl className={classes.inputWrapper}>
                            <InputLabel
                                htmlFor="buildingType"
                                classes={{
                                    error:   classes.error,
                                    focused: classes.labelFocused,
                                    root:    classes.label
                                }}
                                error={Boolean(formik.errors.buildingType) && Boolean(formik.touched.buildingType)}
                            >
                                Building Type<span className={classes.required}> *</span>
                            </InputLabel>
                            <Select
                                value={formik.values.buildingType}
                                onChange={formik.handleChange}
                                className={classes.select}
                                inputProps={{
                                    name:   'buildingType',
                                    id:     'buildingType',
                                    onBlur: formik.handleBlur
                                }}
                                error={Boolean(formik.errors.buildingType) && Boolean(formik.touched.buildingType)}
                            >
                                {
                                    buildingTypes.map(type =>
                                        <MenuItem
                                            key={type.id}
                                            value={type.id}
                                        >
                                            {type.name}
                                        </MenuItem>
                                    )
                                }
                            </Select>
                            {formik.touched.buildingType &&
                             formik.errors.buildingType && <FormHelperText className={classes.error}>{formik.errors.buildingType}</FormHelperText>}
                        </FormControl>
                        <div className={classes.formRow}>
                            <FormControl className={classes.inputWrapper}>
                                <TextField
                                    id="squareFootage"
                                    name="squareFootage"
                                    type="text"
                                    value={formik.values.squareFootage}
                                    label={<span>Area<span className={classes.required}> *</span></span>}
                                    onChange={formik.handleChange}
                                    InputLabelProps={{
                                        classes: {
                                            error:   classes.error,
                                            focused: classes.labelFocused,
                                            root:    classes.label
                                        }
                                    }}
                                    InputProps={{
                                        onBlur:  formik.handleBlur,
                                        classes: {
                                            error:     classes.cssErrorUnderline,
                                            underline: classes.cssUnderline,
                                            root:      classes.input
                                        }
                                    }}
                                    FormHelperTextProps={{
                                        classes: {
                                            error: classes.error
                                        }
                                    }}
                                    error={Boolean(formik.errors.squareFootage) && Boolean(formik.touched.squareFootage)}
                                    helperText={Boolean(formik.touched.squareFootage) && formik.errors.squareFootage}
                                />
                            </FormControl>
                            <FormControl className={classes.inputWrapper}>
                                <InputLabel
                                    htmlFor="squareAreaUOM"
                                    classes={{
                                        error:   classes.error,
                                        focused: classes.labelFocused,
                                        root:    classes.label
                                    }}
                                    error={Boolean(formik.errors.squareAreaUOM) && Boolean(formik.touched.squareAreaUOM)}
                                >
                                    Unit Of Measure<span className={classes.required}> *</span>
                                </InputLabel>
                                <Select
                                    value={formik.values.squareAreaUOM}
                                    onChange={formik.handleChange}
                                    className={classes.select}
                                    inputProps={{
                                        name:   'squareAreaUOM',
                                        id:     'squareAreaUOM',
                                        onBlur: formik.handleBlur
                                    }}
                                    error={Boolean(formik.errors.squareAreaUOM) && Boolean(formik.touched.squareAreaUOM)}
                                >
                                    {
                                        squareAreaUOMTypes.map(uom =>
                                            <MenuItem
                                                key={uom.type}
                                                value={uom.value}
                                            >
                                                {uom.type}
                                            </MenuItem>
                                        )
                                    }
                                </Select>
                                {formik.touched.squareAreaUOM &&
                                formik.errors.squareAreaUOM && <FormHelperText className={classes.error}>{formik.errors.squareAreaUOM}</FormHelperText>}
                            </FormControl>
                        </div>
                        <p className={classes.infoText}><i className="fa fa-info-circle" aria-hidden="true" />Enter the physical address used to fill the address fields below.</p>
                        <PlacesAutocomplete
                            value={formik.values.addressSearch}
                            onChange={address => formik.setFieldValue('addressSearch', address)}
                            onSelect={(handleGeocodeAddress)}
                        >
                            {({ getInputProps, suggestions, getSuggestionItemProps }) => (
                                <React.Fragment>
                                    <FormControl className={classes.inputWrapper}>
                                        <InputLabel
                                            htmlFor="addressSearch"
                                            classes={{
                                                error:   classes.error,
                                                focused: classes.labelFocused,
                                                root:    classes.label
                                            }}
                                            error={Boolean(formik.errors.addressSearch) && Boolean(formik.touched.addressSearch)}
                                        >
                                            Search for Address<span className={classes.required}> *</span>
                                        </InputLabel>
                                        <Input
                                            {...getInputProps({
                                                name: 'addressSearch',
                                                id:   'addressSearch'
                                            })}
                                            classes={{
                                                error:     classes.cssErrorUnderline,
                                                underline: classes.cssUnderline,
                                                root:      classes.input
                                            }}
                                            error={Boolean(formik.errors.addressSearch) && Boolean(formik.touched.addressSearch)}
                                        />
                                        {formik.touched.addressSearch &&
                                         formik.errors.addressSearch && <FormHelperText className={classes.error}>{formik.errors.addressSearch}</FormHelperText>}
                                    </FormControl>
                                    {suggestions.length > 0 && <Paper className={classes.autoCompleteList}>
                                        <List>
                                            {suggestions.map((suggestion, index) => {
                                                return (
                                                    <div key={index}>
                                                        <ListItem
                                                            button
                                                            className={classes.autoCompleteListItem}
                                                            {...getSuggestionItemProps(suggestion)}
                                                        >
                                                            <ListItemText primary={suggestion.description} />
                                                        </ListItem>
                                                    </div>
                                                );
                                            })}
                                        </List>
                                        <GoogleLogo />
                                    </Paper>}
                                </React.Fragment>
                            )}
                        </PlacesAutocomplete>
                        <FormControl className={classes.inputWrapper}>
                            <TextField
                                id="address1"
                                name="address1"
                                type="text"
                                value={address1}
                                label="Address"
                                disabled
                                InputLabelProps={{
                                    classes: {
                                        error:   classes.error,
                                        focused: classes.labelFocused,
                                        root:    classes.label
                                    }
                                }}
                                InputProps={{
                                    classes: {
                                        error:     classes.cssErrorUnderline,
                                        underline: classes.cssUnderline,
                                        root:      classes.input
                                    }
                                }}
                            />
                        </FormControl>
                        <FormControl className={classes.inputWrapper}>
                            <TextField
                                id="city"
                                name="city"
                                type="text"
                                value={city}
                                label="City"
                                disabled
                                InputLabelProps={{
                                    classes: {
                                        error:   classes.error,
                                        focused: classes.labelFocused,
                                        root:    classes.label
                                    }
                                }}
                                InputProps={{
                                    classes: {
                                        error:     classes.cssErrorUnderline,
                                        underline: classes.cssUnderline,
                                        root:      classes.input
                                    }
                                }}
                            />
                        </FormControl>
                        <div className={classes.formRow}>
                            <FormControl className={`${classes.inputWrapper} ${classes.state}`}>
                                <TextField
                                    id="state"
                                    name="state"
                                    type="text"
                                    value={state}
                                    label="State"
                                    disabled
                                    InputLabelProps={{
                                        classes: {
                                            error:   classes.error,
                                            focused: classes.labelFocused,
                                            root:    classes.label
                                        }
                                    }}
                                    InputProps={{
                                        classes: {
                                            error:     classes.cssErrorUnderline,
                                            underline: classes.cssUnderline,
                                            root:      classes.input
                                        }
                                    }}
                                />
                            </FormControl>
                            <FormControl className={`${classes.inputWrapper} ${classes.zip}`}>
                                <TextField
                                    id="zip"
                                    name="zip"
                                    type="text"
                                    value={zip}
                                    label="Zip Code"
                                    disabled
                                    InputLabelProps={{
                                        classes: {
                                            error:   classes.error,
                                            focused: classes.labelFocused,
                                            root:    classes.label
                                        }
                                    }}
                                    InputProps={{
                                        classes: {
                                            error:     classes.cssErrorUnderline,
                                            underline: classes.cssUnderline,
                                            root:      classes.input
                                        }
                                    }}
                                />
                            </FormControl>
                        </div>
                    </div>
                </div>
                <div className={classes.inputColumn}>
                    <div className={classes.inputs}>
                        <FormControl className={classes.inputWrapper}>
                            <InputLabel
                                htmlFor="fuelTypes"
                                classes={{
                                    error:   classes.error,
                                    focused: classes.labelFocused,
                                    root:    classes.label
                                }}
                            >
                                Fuel Types
                            </InputLabel>
                            <Select
                                multiple
                                value={formik.values.fuelTypes}
                                id="fuelTypes"
                                input={<Input id="select-multiple-checkbox" />}
                                renderValue={selected => selected.join(', ')}
                                onChange={formik.handleChange}
                                name="fuelType"
                                className={`${classes.cssUnderline} ${classes.input}`}
                                inputProps={{
                                    name: 'fuelTypes',
                                    id:   'fuelTypes',
                                }}
                            >
                                {
                                    fuelTypes.map(f => f.name).map((type, index) => (
                                        <MenuItem
                                            className={classes.selectMenuItem}
                                            value={type}
                                            key={index}
                                        >
                                            <Checkbox
                                                color="primary"
                                                checked={formik.values.fuelTypes.indexOf(type) > -1}
                                            />

                                            <span>{type}</span>
                                        </MenuItem>
                                    ))
                                }
                            </Select>
                        </FormControl>
                        {
                            isEdit ?
                                <React.Fragment>
                                    <FormControl className={classes.inputWrapper}>
                                        <InputLabel
                                            htmlFor="energyContact"
                                            classes={{
                                                error:   classes.error,
                                                focused: classes.labelFocused,
                                                root:    classes.label
                                            }}
                                            error={Boolean(formik.errors.energyContact) && Boolean(formik.touched.energyContact)}
                                        >
                                            Energy Contact
                                        </InputLabel>
                                        <Select
                                            value={formik.values.energyContact}
                                            id="energyContact"
                                            disabled={!process.env.contactsEnabled}
                                            onChange={formik.handleChange}
                                            name="energyContact"
                                            classes={{
                                                root: classes.input
                                            }}
                                            inputProps={{
                                                onBlur: formik.handleBlur
                                            }}
                                            error={Boolean(formik.errors.energyContact) && Boolean(formik.touched.energyContact)}
                                        >
                                            {
                                                siteContacts.map(type =>
                                                    <MenuItem
                                                        key={type.id}
                                                        value={type.id}
                                                    >
                                                        {`${type.userName.FirstName} ${type.userName.LastName}`}
                                                    </MenuItem>
                                                )
                                            }
                                        </Select>
                                        {formik.touched.energyContact &&
                                         formik.errors.energyContact && <FormHelperText className={classes.error}>{formik.errors.energyContact}</FormHelperText>}
                                    </FormControl>
                                    <FormControl className={classes.inputWrapper}>
                                        <InputLabel
                                            htmlFor="facilitiesContact"
                                            classes={{
                                                error:   classes.error,
                                                focused: classes.labelFocused,
                                                root:    classes.label
                                            }}
                                            error={Boolean(formik.errors.facilitiesContact) && Boolean(formik.touched.facilitiesContact)}
                                        >
                                            Facilities Contact
                                        </InputLabel>
                                        <Select
                                            value={formik.values.facilitiesContact}
                                            id="facilitiesContact"
                                            disabled={!process.env.contactsEnabled}
                                            onChange={formik.handleChange}
                                            name="facilitiesContact"
                                            classes={{
                                                root: classes.input
                                            }}
                                            inputProps={{
                                                onBlur: formik.handleBlur
                                            }}
                                            error={Boolean(formik.errors.facilitiesContact) && Boolean(formik.touched.facilitiesContact)}
                                        >
                                            {
                                                siteContacts.map(type =>
                                                    <MenuItem
                                                        key={type.id}
                                                        value={type.id}
                                                    >
                                                        {`${type.userName.FirstName} ${type.userName.LastName}`}
                                                    </MenuItem>
                                                )
                                            }
                                        </Select>
                                        {formik.touched.facilitiesContact &&
                                         formik.errors.facilitiesContact && <FormHelperText className={classes.error}>{formik.errors.facilitiesContact}</FormHelperText>}
                                    </FormControl>
                                    <FormControl className={classes.inputWrapper}>
                                        <InputLabel
                                            htmlFor="salesContact"
                                            classes={{
                                                error:   classes.error,
                                                focused: classes.labelFocused,
                                                root:    classes.label
                                            }}
                                            error={Boolean(formik.errors.salesContact) && Boolean(formik.touched.salesContact)}
                                        >
                                            Sales Contact
                                        </InputLabel>
                                        <Select
                                            value={formik.values.salesContact}
                                            id="salesContact"
                                            disabled={!process.env.contactsEnabled}
                                            onChange={formik.handleChange}
                                            name="salesContact"
                                            classes={{
                                                root: classes.input
                                            }}
                                            inputProps={{
                                                onBlur: formik.handleBlur
                                            }}
                                            error={Boolean(formik.errors.salesContact) && Boolean(formik.touched.salesContact)}
                                        >
                                            {
                                                siteContacts.map(type =>
                                                    <MenuItem
                                                        key={type.id}
                                                        value={type.id}
                                                    >
                                                        {`${type.userName.FirstName} ${type.userName.LastName}`}
                                                    </MenuItem>
                                                )
                                            }
                                        </Select>
                                        {formik.touched.salesContact &&
                                         formik.errors.salesContact && <FormHelperText className={classes.error}>{formik.errors.salesContact}</FormHelperText>}
                                    </FormControl>
                                </React.Fragment>
                                :
                                null
                        }
                        {
                            companyApplications.includes('Energy') ?
                                <FormControl className={classes.inputWrapper}>
                                    <InputLabel
                                        htmlFor="energySite"
                                        classes={{
                                            error:   classes.error,
                                            focused: classes.labelFocused,
                                            root:    classes.label
                                        }}
                                        error={Boolean(formik.errors.salesContact) && Boolean(formik.touched.salesContact)}
                                    >
                                        Energy Site
                                    </InputLabel>
                                    <Select
                                        value={formik.values.energySite}
                                        id="energySite"
                                        onChange={formik.handleChange}
                                        name="energySite"
                                        classes={{
                                            root: classes.input
                                        }}
                                        inputProps={{
                                            onBlur: formik.handleBlur
                                        }}
                                        error={Boolean(formik.errors.energySite) && Boolean(formik.touched.energySite)}
                                    >
                                        <MenuItem
                                            key={0}
                                            value={''}
                                        >
                                            None
                                        </MenuItem>
                                        {
                                            energyIntegrations.map((integration, index) =>
                                                <MenuItem
                                                    key={index}
                                                    disabled={integration.isSiteLinked}
                                                    value={integration.integrationId}
                                                >
                                                    {integration.propertyName}
                                                </MenuItem>
                                            )
                                        }
                                    </Select>
                                    {formik.touched.energySite &&
                                     formik.errors.energySite && <FormHelperText className={classes.error}>{formik.errors.energySite}</FormHelperText>}
                                </FormControl>
                                :
                                null
                        }
                        <FormControl className={`${classes.inputWrapper}`}>
                            <TimeZoneAutoSelect
                                onBlur={formik.handleBlur}
                                onChange={formik.handleChange}
                                value={formik.values.timeZone}
                                error={Boolean(formik.errors.timeZone) && Boolean(formik.touched.timeZone)}
                                helperText={Boolean(formik.touched.timeZone) && formik.errors.timeZone}
                                label={<span>Time Zone<span className={classes.required}> *</span></span>}
                                placeholder="Time Zone"
                            />
                        </FormControl>
                    </div>
                </div>
            </div>
            <React.Fragment>
                <Button
                    className={classes.Button}
                    onClick={handleCancel}
                    variant="contained"
                >
                    Cancel
                </Button>
                <BobConfirmButton
                    className={classes.ButtonWithMargin}
                    disabled={formik.isSubmitting || isLoading}
                    isLoading={isLoading}
                    label={isEdit ? 'Update' : 'Create'}
                    onClick={formik.handleSubmit}
                />
            </React.Fragment>
            {
                bobLoading.includes('fetchSite') ?
                    <BobLoadingMask />
                    :
                    null
            }
        </React.Fragment>
    );
};

CreateSiteModal.defaultProps = {
    buildingTypes: [],
    clientNodes:   [],
    fuelTypes:     [],
    selectedNode:  {}
};


CreateSiteModal.propTypes = {
    buildingTypes: array,
    clientNodes:   array,
    fuelTypes:     array,
    selectedNode:  object,
};

const mapStateToProps = state => {
    return {
        bobLoading:          state.bob.bobLoading,
        buildingTypes:       state.architect.buildingTypes,
        clientNodes:         state.architect.clientNodes,
        companyApplications: state.bob.companyApplications,
        contacts:            state.architect.contacts,
        energyIntegrations:  state.dashboard.energyIntegrations,
        errors:              state.messages.errors,
        fuelTypes:           state.architect.fuelTypes,
        isLoading:           state.ui.isLoading,
        navClients:          state.bob.navClients,
        selectedNode:        state.architect.selectedNode,
        siteContacts:        state.contact.siteContacts,
        targetNavClient:     state.bob.targetNavClient,
        targetNavCompany:    state.bob.targetNavCompany,
        activeNavClient:     state.bob.activeNavClient
    };
};

const mapDispatchToProps = {
    ...ArchitectActions,
    ...ApplicationMessageActions,
    ...ContactActions,
    ...DashboardActions,
    ...UiActions
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(CreateSiteModal));
